import ItiButton from "../../../iti-core-react/components/ItiButton/ItiButton";
import ItiForm from "../../../iti-core-react/components/ItiForm/ItiForm";
import { ItiMessageService } from "../../../iti-core-react/services/iti-message-service";
interface ItiBaseProps {
	title?: string;
	buttonText?: string;
	icon?: string;
	showSubmit?: boolean;
	showCancel?: boolean;
	showShare?: boolean;
	showStopShare?: boolean;
	showFloorBackButton?: boolean;
	saveDisabled?: boolean;
	shareDisabled?: boolean;
	stopShareDisabled?: boolean;
	card?: boolean;
	showValidation?: boolean;
	children?: any;
	buttons?: any;
	showBackButton?: boolean;
	showEditButton?: boolean;
	showRestoreButton?: boolean;
	showDeleteButton?: boolean;
	showDeletePermanentlyButton?: boolean;
	saveVisible?: boolean;
	shareVisible?: boolean;
	stopShareVisible?: boolean;
	showGoNext?: boolean;
	goNextDisabled?: boolean;
	goNextVisible?: boolean;
	previewVisible?: boolean;
	previewDisabled?: boolean;
	showPreview?: boolean;
	isPopup?: boolean;
	noForm?: boolean;
	classes?: {
		containerButtons?: string;
		buttons?: string;
		paddingForm?: string;
	};
	showPaddingForm?: boolean;
	showPaddingTop?: boolean;
	paddingClasses?: string;
	idMenuOptions?: string;
	cancelText?: string;
	rowClass?: string;
	optionsMenuClass?: string;
	backButtonText?: string;
	onSave?: () => void;
	onCancel?: () => void;
	onBack?: () => void;
	onShare?: () => void;
	onGoNext?: () => void;
	onPreview?: () => void;
	onStopShare?: () => void;
	onFloorBackButton?: () => void;
	onEdit?: () => void;
	onDelete?: () => void;
	onDeletePermanently?: () => void;
	onRestore?: () => void;
	onModifiedForm?: () => void;
	onOptionsChange?: (
		options: Array<{ text: string; icon: string; onClick: () => void }>,
	) => void;
}

export default function BaseForm({
	title,
	buttonText = "save",
	icon = "",
	showSubmit = true,
	showCancel = true,
	showShare = false,
	showStopShare = false,
	showFloorBackButton = false,
	saveDisabled = false,
	shareDisabled = false,
	stopShareDisabled = false,
	previewVisible = false,
	previewDisabled = false,
	showPreview = false,
	card,
	showValidation,
	children,
	buttons,
	showPaddingTop = true,
	showBackButton = false,
	showEditButton = false,
	showRestoreButton = false,
	showDeleteButton = false,
	showDeletePermanentlyButton = false,
	classes,
	saveVisible = true,
	shareVisible = true,
	goNextVisible = true,
	goNextDisabled = false,
	showGoNext = false,
	stopShareVisible = true,
	isPopup = false,
	noForm = false,
	showPaddingForm = true,
	paddingClasses,
	idMenuOptions = "menu-options",
	cancelText = "cancel",
	rowClass,
	optionsMenuClass,
	backButtonText,
	onSave = () => {},
	onShare = () => {},
	onGoNext = () => {},
	onStopShare = () => {},
	onCancel = () => {},
	onPreview = () => {},
	onFloorBackButton = () => {},
	onEdit = () => {},
	onBack = () => {},
	onRestore = () => {},
	onDelete,
	onDeletePermanently,
	onOptionsChange,
}: Readonly<ItiBaseProps>) {
	const onValidateClick = (e: any) => {
		if (e.validationGroup.validate().isValid) {
			onSave();
			onShare();
			onGoNext();
			if (showValidation) {
				ItiMessageService.toastSuccess("messages.correct");
			}
		} else {
			if (showValidation) {
				ItiMessageService.toastError("messages.incorrect");
			}
		}
	};

	const getButtons = () => {
		return (
			<>
				{buttons}
				{showCancel && (
					<ItiButton
						type="default"
						text={cancelText}
						onClick={onCancel}
						tabIndex={0}
						elementAttr={{ class: "iti-button-cancel" }}
					/>
				)}
				{showPreview && (
					<ItiButton
						type="default"
						text="preview"
						icon="mdi mdi-eye"
						elementAttr={{ class: "iti-button-preview" }}
						disabled={previewDisabled}
						visible={previewVisible}
						onClick={onPreview}
						tabIndex={0}
					/>
				)}
				{showFloorBackButton && (
					<ItiButton
						type="default"
						text="back"
						icon="back"
						onClick={onFloorBackButton}
						tabIndex={0}
					/>
				)}
				{showSubmit && (
					<ItiButton
						stylingMode="contained"
						type="default"
						icon={icon}
						text={buttonText}
						disabled={saveDisabled}
						visible={saveVisible}
						onClick={onValidateClick}
						tabIndex={0}
						elementAttr={{ class: "iti-button-save" }}
					/>
				)}
				{showStopShare && (
					<ItiButton
						stylingMode="contained"
						type="default"
						text="stop-sharing"
						icon="mdi mdi-link-variant-remove"
						disabled={stopShareDisabled}
						visible={stopShareVisible}
						onClick={onStopShare}
						tabIndex={0}
					/>
				)}
				{showShare && (
					<ItiButton
						stylingMode="contained"
						type="default"
						text="share"
						icon="share"
						disabled={shareDisabled}
						visible={shareVisible}
						onClick={onValidateClick}
						tabIndex={0}
					/>
				)}
				{showGoNext && (
					<ItiButton
						stylingMode="contained"
						type="default"
						text="next"
						icon="mdi mdi-chevron-right"
						elementAttr={{ class: "iti-button-save" }}
						disabled={goNextDisabled}
						visible={goNextVisible}
						onClick={onValidateClick}
						tabIndex={0}
					/>
				)}
			</>
		);
	};

	return (
		<ItiForm
			buttons={getButtons()}
			card={card}
			title={title}
			showPaddingTop={showPaddingTop}
			onEdit={onEdit}
			onBack={onBack}
			onDelete={onDelete}
			onDeletePermanently={onDeletePermanently}
			onRestore={onRestore}
			optionsMenuClass={optionsMenuClass}
			rowClass={rowClass}
			paddingClasses={paddingClasses}
			showPaddingForm={showPaddingForm}
			showRestoreButton={showRestoreButton}
			showEditButton={showEditButton}
			showBackButton={showBackButton}
			showDeleteButton={showDeleteButton}
			showDeletePermanentlyButton={showDeletePermanentlyButton}
			classes={classes}
			isPopup={isPopup}
			noForm={noForm}
			idMenuOptions={idMenuOptions}
			onOptionsChange={onOptionsChange}
			backButtonText={backButtonText}
		>
			{children}
		</ItiForm>
	);
}
